import React from 'react'
import {TransProps} from "@lingui/react";


// Type
export type typeBadge = {
    color: 'gray' | 'red' | 'yellow' | 'green' | 'blue'
    message: React.ReactElement<TransProps> | string
}


// Component
export const Badge: React.FC<typeBadge> = ({color, message}) => {

    let bgColor = 'bg-indigo-100'
    let textColor = 'text-indigo-800'

    switch (color) {
        case 'gray':
            bgColor = 'bg-gray-100'
            textColor = 'text-gray-800'
            break
        case 'red':
            bgColor = 'bg-red-100'
            textColor = 'text-red-800'
            break
        case 'yellow':
            bgColor = 'bg-yellow-100'
            textColor = 'text-yellow-800'
            break
        case 'green':
            bgColor = 'bg-green-100'
            textColor = 'text-green-800'
            break
        case 'blue':
            bgColor = 'bg-blue-100'
            textColor = 'text-blue-800'
            break
    }

    return(
        <span className={`flex items-center px-2 py-0.5 rounded text-xs font-medium ${bgColor} ${textColor}  cursor-default`}>
            {message}
        </span>
    )
}
